import { render, staticRenderFns } from "./VotingMasterList.vue?vue&type=template&id=1152234c&"
import script from "./VotingMasterList.vue?vue&type=script&lang=js&"
export * from "./VotingMasterList.vue?vue&type=script&lang=js&"
import style0 from "./VotingMasterList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports